/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useReducer, useState } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import { useParams } from 'react-router-dom'
import { Box, Button, Card, CardContent, Checkbox, FormControlLabel, LinearProgress, MenuItem, Paper, Radio, RadioGroup, TextField, Tooltip, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import PaymentForm from '../components/paymentsTab/PaymentForm';
import RemitterForm from '../components/paymentsTab/RemitterForm';
import UserContext from '../../../context/UserContext';
import CreditCardModal from '../components/paymentsTab/CardFormModal';
import OpenBatchModal from '../components/batches/OpenBatchModal';
import { ThemeModeContext, apiRoute } from '../../../App';
import { BatchContext } from '../../../context/BatchMgmtContext';
import { CaseContext } from '../../../context/CaseContext';
import { SystemContext } from '../../../context/SystemContext';
import { commaMoneyFormat, formatMoney } from '../../../Utils';

const PaymentModals = (props) => {
    const {
        handleClose,
        violationBalance,
        openBatches,
        violationView,
        updateCaseBalance,
        violation,
        setViolation,
        modalType,
        ts,
        loading,
        setLoading,
        selectedPayment,
        handleOpen,
        receiptNumber,
        setReceiptNumber,
        citationState,
        retrieveReceiptPayment,
        setRetrieveReceiptPayment,
        overridedPartialPayment,
        violationRows,
        setViolationRows,
        checked,
        setChecked,
        left,
        setLeft,
        right,
        setRight,
        checkedItems,
        setCheckedItems,
        chargeBack,
        setChargeBack,
        chargeBackSettleDate,
        setChargeBackSettleDate,
        chargeBackSettlement,
        setChargeBackSettlement,
    } = props;

    const { setCaseHistoryRows, caseHistoryRows, setBalance, chargesRows, setChargesRows, balance, pkViolations, setPkViolations, } = useContext(CaseContext);
    const { paymentOptions } = useContext(SystemContext)
    const { userName } = useContext(UserContext);
    const [selectedStatuteDesc, setSelectedStatuteDesc] = useState('');
    let calculatedViolationBalance = modalType === 'quickPayment' ? violationRows.reduce((sum, violation) => sum + violation.balance, 0) : violationBalance;
    const { entityId, userId, convenienceFeeRate } = useContext(UserContext);
    const { setOpenBatches } = useContext(BatchContext);
    const { mode } = useContext(ThemeModeContext);
    const { caseNumber } = useParams();
    // null variable so the open batch modal can be called
    const selectedRow = {};

    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [emailCheck, setEmailCheck] = useState(false);
    const [printCheck, setPrintCheck] = useState(false);
    const [textCheck, setTextCheck] = useState(false);
    const [receiptError, setReceiptError] = useState({});

    // QUICK PAYMENT CHECK FOR CREDIT CARD PAYMENT MODAL
    const [quickCheck, setQuickCheck] = useState(false);
    const [noViolation, setNoViolation] = useState('');

    // STATE FOR NEW REMAINING BALANCE BASED ON PAYMENT AMOUNT FOR QUICK PAYMENTS
    const [newCaseBalance, setNewCaseBalance] = useState(balance);

    // EDIT PAYMENT TYPE STATES
    const [paymentType, setPaymentType] = useState(selectedPayment.paymentType);
    const [checkNumber, setCheckNumber] = useState(selectedPayment.checkNumber || "");

    // GETTING DISPLAY BALANCE FOR PAYMENT FORMS
    const [displayBalance, setDisplayBalance] = useState(violationBalance);
    const [convenienceRate,] = useState(convenienceFeeRate);
    const [convenienceFee, setConvenienceFee] = useState((displayBalance * convenienceRate).toFixed(2))
    const [grandTotal, setGrandTotal] = useState(0.00)
    const [currentCaseBalance, setCurrentCaseBalance] = useState(0);

    // REFUND AND REVERSE PAYMENT STATES
    const [notes, setNotes] = useState('');

    // OPEN BATCH STATES
    const [batchType, setBatchType] = useState('SIMPLE');
    const [batchDate, setBatchDate] = useState(dayjs(new Date()));

    const [ccPaymentAmount, setCcPaymentAmount] = useState(0);

    const [masterReceipt, setMasterReceipt] = useState(0);
    const [batchName, setBatchName] = useState(`Batch ${userName}`);
    const [grand, setGrand] = useState();
    const [change, setChange] = useState(0.00);
    const [totalPayment, setTotalPayment] = useState(0.00);
    const [updatePaymentBatchNumber, setUpdatePaymentBatchNumber] = useState('0');

    const [applyToViolations, setApplyToViolations] = useState(false);
    const [applyToOverpayment, setApplyToOverpayment] = useState(false);
    const [amountLeftoverFromSettlement, setAmountLeftoverFromSettlement] = useState(0.00);
    const [amountToApplyToViolations, setAmountToApplyToViolations] = useState(0.00);
    const [amountToApplyToOverpayment, setAmountToApplyToOverpayment] = useState(0.00);
    const [chargebackFee, setChargebackFee] = useState(0.00);
    const [caseBalance, setCaseBalance] = useState(0.00);

    // USEREDUCER FORM DATA FOR REMITTER FORM FOR CREATING PAYMENTS
    const initialRemitterState = {
        payToName: modalType === 'refundPayment' ? selectedPayment.payToName : '',
        payToAddress1: modalType === 'refundPayment' ? selectedPayment.payToAddress1 : '',
        payToAddress2: modalType === 'refundPayment' ? selectedPayment.payToAddress2 || '' : '',
        payToCity: modalType === 'refundPayment' ? selectedPayment.payToCity : '',
        payToState: modalType === 'refundPayment' ? selectedPayment.payToState : '',
        payToZip: modalType === 'refundPayment' ? selectedPayment.payToZip : '',
    };

    const reducer = (state, action) => {
        switch (action.type) {
            case 'UPDATE_FIELD':
                return {
                    ...state,
                    [action.field]: action.value,
                    errors: {
                        ...state.errors,
                        [action.field]: action.error,
                    },
                };
            case 'UPDATE_FIELD_ERROR':
                return {
                    ...state,
                    errors: {
                        ...state.errors,
                        [action.field]: action.error,
                    }
                };
            case 'CLEAR_FIELD_ERROR':
                return {
                    ...state,
                    bond: (() => {
                        const updatedErrors = { ...state.errors };
                        delete updatedErrors[action.field];
                        return {
                            ...state,
                            errors: updatedErrors,
                        };
                    }),
                };
            default:
                return state;
        }
    };

    const [state, dispatch] = useReducer(reducer, initialRemitterState);

    // EDIT PAYMENT TYPE FUNCTION
    const editPaymentType = async () => {
        setLoading(true);
        try {
            await axios.put(`${apiRoute}/api/ffpaymenttbls/${selectedPayment.pkFfPaymentId}`, {
                paymentType: paymentType,
                checkNumber: checkNumber
            })
            // Update the payment type in the local state
            const updatedRows = caseHistoryRows.map((row) => {
                if (row.id === selectedPayment.pkFfPaymentId) {
                    return { ...row, paymentType: paymentType };
                }
                return row;
            });
            setCaseHistoryRows(updatedRows);
            handleClose();
            toast.success('Payment type change successful.', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        } catch (err) {
            toast.error('An error occurred while updating the payment type.', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const balanceDue = checkedItems.reduce((total, item) => total + item.remainingBalance, 0);
        setCurrentCaseBalance(balanceDue);
    }, [checkedItems]);

    // REFUND PAYMENT FUNCTION
    const refundPayment = async () => {
        setLoading(true);
        let paymentNotes;
        if (notes === '') {
            paymentNotes = null
        } else {
            paymentNotes = notes;
        }
        try {
            const res = await axios.post(`${apiRoute}/api/ffpaymenttbls/refund`, { paymentIds: selectedPayment.paymentIds, notes: paymentNotes, batchNumber: updatePaymentBatchNumber, chargeBack: chargeBack },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
            try {
                const newRefund = {
                    ...res.data.refundPaymentRecord[0],
                    id: res.data.refundPaymentRecord[0].masterReceipt,
                    violations: res.data.refundPaymentRecord.map(r => r.fkViolationId),
                    paymentIds: res.data.refundPaymentRecord.map(r => r.pkFfPaymentId),
                    paymentAmount: res.data.refundPaymentRecord.reduce((acc, item) => acc += item.paymentAmount, 0),
                    paymentRef: res.data.refundPaymentRecord.filter(e => e.paymentRef != null || e.paymentRef !== undefined).map(e => e.paymentRef),
                    paymentDate: res.data.refundPaymentRecord[0].paymentDate
                        ? new Date(res.data.refundPaymentRecord[0].paymentDate).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit'
                        }).replace(/\//g, '-')
                        : '',
                    dateEnter: res.data.refundPaymentRecord[0].dateEnter
                        ? new Date(res.data.refundPaymentRecord[0].dateEnter).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit'
                        }).replace(/\//g, '-')
                        : '',
                };
                const editedPayment = {
                    ...res.data.existingPayments[0],
                    id: res.data.existingPayments[0].masterReceipt,
                    violations: res.data.existingPayments.map(r => r.fkViolationId),
                    paymentIds: res.data.existingPayments.map(r => r.pkFfPaymentId),
                    refundReason: 'REFUND',
                    paymentAmount: res.data.existingPayments.reduce((acc, item) => acc += item.paymentAmount, 0),
                    paymentRef: res.data.existingPayments.filter(e => e.paymentRef != null || e.paymentRef !== undefined).map(e => e.paymentRef),
                    paymentDate: res.data.existingPayments[0].paymentDate
                        ? new Date(res.data.existingPayments[0].paymentDate).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit'
                        }).replace(/\//g, '-')
                        : '',
                    dateEnter: res.data.existingPayments[0].dateEnter
                        ? new Date(res.data.existingPayments[0].dateEnter).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit'
                        }).replace(/\//g, '-')
                        : '',
                };

                // Find the index of the row to update
                const rowIndex = caseHistoryRows?.findIndex(({ id }) => id === editedPayment.id);

                if (rowIndex !== -1) {
                    // Create a new array with the updated row
                    const updatedRows = [
                        ...caseHistoryRows.slice(0, rowIndex),
                        editedPayment,
                        ...caseHistoryRows.slice(rowIndex + 1)
                    ];

                    // Update the state
                    setCaseHistoryRows([...updatedRows, newRefund]);
                };

                for (const payment in res.data.refundPaymentRecord) {

                    // get the violationId attached to the payment
                    const violationId = payment.fkViolationId


                    // Find the specific violation in violationRows
                    const updatedViolationIndex = violationRows?.findIndex(({ pkViolationId }) => pkViolationId === violationId);

                    if (updatedViolationIndex !== -1) {

                        //Find the row to adjust, make sure convenience fee is accounted for
                        const updatedViolationRows = [...violationRows];
                        updatedViolationRows[updatedViolationIndex].remainingBalance -= (payment.paymentAmount - payment.convenienceFee);
                        setViolationRows(updatedViolationRows);

                        // Filtering vio rows based on the remaining balance to keep unwanted charges from seeping into charges box
                        setChargesRows(updatedViolationRows.filter(row => row.remainingBalance > 0.00).map(row => row));

                        // Calculate total remaining balance
                        const totalRemainingBalance = updatedViolationRows.reduce((total, violation) => total + violation.remainingBalance, 0);

                        // Update the balance state with the total remaining balance
                        setBalance(totalRemainingBalance);
                    }
                }
                toast.success(`Payment Refunded.`, {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                handleClose();
                setUpdatePaymentBatchNumber('0');
                await updateCaseBalance();
            } catch (err) {
                console.log(err);
                toast.success(`Error Refunding Payment. ${err.message}`, {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }
        } catch (err) {
            console.log('err refunding payment: ', err);
            toast.success(`Error Refunding Payment. ${err?.message ?? ''}`, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        } finally {
            setLoading(false);
        }
    };

    // REVERSE PAYMENT FUNCTION
    const reversePayment = async () => {
        setLoading(true);
        let paymentNotes;
        if (notes === '') {
            paymentNotes = null
        } else {
            paymentNotes = notes;
        }
        try {
            const res = await axios.post(`${apiRoute}/api/ffpaymenttbls/reversal`, { paymentIds: selectedPayment.paymentIds, notes: paymentNotes, batchNumber: updatePaymentBatchNumber },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
            try {
                const newRefund = {
                    ...res.data.reversalPaymentRecord,
                    id: res.data.reversalPaymentRecord.pkFfPaymentId,
                    paymentDate: res.data.reversalPaymentRecord.paymentDate ? new Date(res.data.reversalPaymentRecord.paymentDate).toISOString().split('T')[0] : '',
                    dateEnter: res.data.reversalPaymentRecord.dateEnter ? new Date(res.data.reversalPaymentRecord.dateEnter).toISOString().split('T')[0] : '',
                };
                const editedPayment = {
                    ...res.data.existingPayment,
                    id: res.data.existingPayment.pkFfPaymentId,
                    refundReason: 'REVERSAL',
                    paymentDate: res.data.existingPayment.paymentDate ? new Date(res.data.existingPayment.paymentDate).toISOString().split('T')[0] : '',
                    dateEnter: res.data.existingPayment.dateEnter ? new Date(res.data.existingPayment.dateEnter).toISOString().split('T')[0] : '',
                };
                // get the violationId attached to the payment
                const violationId = res.data.existingPayment.fkViolationId

                // Find the index of the row to update
                const rowIndex = caseHistoryRows.findIndex(row => row.id === editedPayment.id);

                if (rowIndex !== -1) {
                    // Create a new array with the updated row
                    const updatedRows = [
                        ...caseHistoryRows.slice(0, rowIndex),
                        editedPayment,
                        ...caseHistoryRows.slice(rowIndex + 1)
                    ];

                    // Update the state
                    setCaseHistoryRows([...updatedRows, newRefund]);
                };

                // Find the specific violation in violationRows
                const updatedViolationIndex = violationRows.findIndex(vio => vio.pkViolationId === violationId);

                if (updatedViolationIndex !== -1) {

                    //Find the row to adjust, make sure convenience fee is accounted for
                    const updatedViolationRows = [...violationRows];
                    updatedViolationRows[updatedViolationIndex].remainingBalance -= (res.data.reversalPaymentRecord.paymentAmount - res.data.reversalPaymentRecord.convenienceFee);
                    setViolationRows(updatedViolationRows);

                    // Filtering vio rows based on the remaining balance to keep unwanted charges from seeping into charges box
                    setChargesRows(updatedViolationRows.filter(row => row.remainingBalance > 0.00).map(row => row));

                    // Calculate total remaining balance
                    const totalRemainingBalance = updatedViolationRows.reduce((total, violation) => total + violation.remainingBalance, 0);

                    // Update the balance state with the total remaining balance
                    setBalance(totalRemainingBalance);
                }

                toast.success(`Payment Reversed.`, {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                handleClose();
                setUpdatePaymentBatchNumber('0');
            } catch (err) {
                console.log(err);
                toast.success(`Error Reversing Payment. ${err.message}`, {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }
        } catch (err) {
            console.log('err reversing payment: ', err);
        } finally {
            setLoading(false);
        }
    };

    const voidPayment = async () => {
        setLoading(true);
        let paymentNotes;
        if (notes === '') {
            paymentNotes = ""
        } else {
            paymentNotes = notes;
        }

        try {
            const res = await axios.post(`${apiRoute}/api/ffpaymenttbls/void/addVoidedPayment`, { paymentIds: selectedPayment.paymentIds, notes: paymentNotes, batchNumber: updatePaymentBatchNumber, chargeBack: chargeBack },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
            try {
                const voidPayment = {
                    ...res.data.voidPaymentRecord[0],
                    id: res.data.voidPaymentRecord[0].masterReceipt,
                    violations: res.data.voidPaymentRecord.map(r => r.fkViolationId),
                    paymentIds: res.data.voidPaymentRecord.map(r => r.pkFfPaymentId),
                    paymentAmount: res.data.voidPaymentRecord.reduce((acc, item) => acc += item.paymentAmount, 0),
                    paymentRef: res.data.voidPaymentRecord.filter(e => e.paymentRef != null || e.paymentRef !== undefined).map(e => e.paymentRef),
                    paymentDate: res.data.voidPaymentRecord[0].paymentDate
                        ? new Date(res.data.voidPaymentRecord[0].paymentDate).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit'
                        }).replace(/\//g, '-')
                        : '',
                    dateEnter: res.data.voidPaymentRecord[0].dateEnter
                        ? new Date(res.data.voidPaymentRecord[0].dateEnter).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit'
                        }).replace(/\//g, '-')
                        : '',
                };
                const editedPayment = {
                    ...res.data.existingPayments[0],
                    id: res.data.existingPayments[0].masterReceipt,
                    refundReason: 'VOID',
                    violations: res.data.existingPayments.map(r => r.fkViolationId),
                    paymentIds: res.data.existingPayments.map(r => r.pkFfPaymentId),
                    paymentAmount: res.data.existingPayments.reduce((acc, item) => acc += item.paymentAmount, 0),
                    paymentRef: res.data.existingPayments.filter(e => e.paymentRef != null || e.paymentRef !== undefined).map(e => e.paymentRef),
                    paymentDate: res.data.existingPayments[0].paymentDate
                        ? new Date(res.data.existingPayments[0].paymentDate).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit'
                        }).replace(/\//g, '-')
                        : '',
                    dateEnter: res.data.existingPayments[0].dateEnter
                        ? new Date(res.data.existingPayments[0].dateEnter).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit'
                        }).replace(/\//g, '-')
                        : '',
                };

                // Find the index of the row to update
                const rowIndex = caseHistoryRows?.findIndex(({ id }) => id === editedPayment.id);

                if (rowIndex !== -1) {
                    // Create a new array with the updated row
                    const updatedRows = [
                        ...caseHistoryRows.slice(0, rowIndex),
                        editedPayment,
                        ...caseHistoryRows.slice(rowIndex + 1)
                    ];
                    // Update the state
                    setCaseHistoryRows([...updatedRows, voidPayment]);
                };
                for (const payment in res.data.voidPaymentRecord) {
                    const violationId = payment.fkViolationId
                    const updatedViolationIndex = violationRows?.findIndex(({ pkViolationId }) => pkViolationId === violationId);
                    if (updatedViolationIndex !== -1) {
                        const updatedViolationRows = [...violationRows];
                        updatedViolationRows[updatedViolationIndex].remainingBalance -= (payment.paymentAmount - payment.convenienceFee);
                        setViolationRows(updatedViolationRows);
                        setChargesRows(updatedViolationRows.filter(row => row.remainingBalance > 0.00).map(row => row));
                        const totalRemainingBalance = updatedViolationRows.reduce((total, violation) => total + violation.remainingBalance, 0);
                        setBalance(totalRemainingBalance);
                    }
                }
                toast.success(`Payment Voided.`, {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                handleClose();
                setUpdatePaymentBatchNumber('0');
                await updateCaseBalance();
            } catch (err) {
                console.log(err);
                toast.success(`Error Voiding Payment. ${err.message}`, {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }
        } catch (err) {
            console.log('err voiding payment: ', err);
        } finally {
            setLoading(false);
        }
    };

    const createChargeBackSettlementPayment = async () => {
        setLoading(true);
        let paymentNotes;
        if (notes === '') {
            paymentNotes = ""
        } else {
            paymentNotes = notes;
        }
        console.log('selectedPayment: ', selectedPayment);
        try {
            const res = await axios.post(`${apiRoute}/api/ffpaymenttbls/chargeBackSettlement`, { paymentIds: selectedPayment.paymentIds, notes: paymentNotes, batchNumber: updatePaymentBatchNumber, chargeBack: chargeBack, settleDate: chargeBackSettleDate },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
            try {
                const chargeBackSettlement = {
                    ...res.data.chargeBackPayment[0],
                    id: res.data.chargeBackPayment[0].masterReceipt,
                    violations: res.data.chargeBackPayment.map(r => r.fkViolationId),
                    paymentIds: res.data.chargeBackPayment.map(r => r.pkFfPaymentId),
                    paymentRef: res.data.existingPayments.filter(e => e.paymentRef != null || e.paymentRef !== undefined).map(e => e.paymentRef),
                    paymentAmount: res.data.chargeBackPayment.reduce((acc, item) => acc += item.paymentAmount, 0),
                    paymentDate: res.data.chargeBackPayment[0].paymentDate
                        ? new Date(res.data.chargeBackPayment[0].paymentDate).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit'
                        }).replace(/\//g, '-')
                        : '',
                    dateEnter: res.data.chargeBackPayment[0].dateEnter
                        ? new Date(res.data.chargeBackPayment[0].dateEnter).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit'
                        }).replace(/\//g, '-')
                        : '',
                };
                const editedPayment = {
                    ...res.data.existingPayments[0],
                    id: res.data.existingPayments[0].masterReceipt,
                    refundReason: 'CHARGEBACK REVERSAL',
                    violations: res.data.existingPayments.map(r => r.fkViolationId),
                    paymentIds: res.data.existingPayments.map(r => r.pkFfPaymentId),
                    paymentDate: res.data.existingPayments[0].paymentDate
                        ? new Date(res.data.existingPayments[0].paymentDate).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit'
                        }).replace(/\//g, '-')
                        : '',
                    dateEnter: res.data.existingPayments[0].dateEnter
                        ? new Date(res.data.existingPayments[0].dateEnter).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit'
                        }).replace(/\//g, '-')
                        : '',
                    paymentAmount: res.data.existingPayments.reduce((acc, item) => acc += item.paymentAmount, 0),
                    paymentRef: res.data.existingPayments.filter(e => e.paymentRef != null || e.paymentRef !== undefined).map(e => e.paymentRef),
                    chargeBackSettled: true
                };

                // Find the index of the row to update
                const rowIndex = caseHistoryRows?.findIndex(({ id }) => id === editedPayment.id);

                if (rowIndex !== -1) {
                    // Create a new array with the updated row
                    const updatedRows = [
                        ...caseHistoryRows.slice(0, rowIndex),
                        editedPayment,
                        ...caseHistoryRows.slice(rowIndex + 1)
                    ];

                    // Update the state
                    setCaseHistoryRows([...updatedRows, chargeBackSettlement]);
                };

                for (const payment in res.data.chargeBackPayment) {
                    // get the violationId attached to the payment
                    const violationId = payment.fkViolationId
                    // Find the specific violation in violationRows
                    const updatedViolationIndex = violationRows?.findIndex(({ pkViolationId }) => pkViolationId === violationId);

                    if (updatedViolationIndex !== -1) {

                        //Find the row to adjust, make sure convenience fee is accounted for
                        const updatedViolationRows = [...violationRows];
                        updatedViolationRows[updatedViolationIndex].remainingBalance -= (payment.paymentAmount - payment.convenienceFee);
                        setViolationRows(updatedViolationRows);

                        // Filtering vio rows based on the remaining balance to keep unwanted charges from seeping into charges box
                        setChargesRows(updatedViolationRows.filter(row => row.remainingBalance > 0.00).map(row => row));

                        // Calculate total remaining balance
                        const totalRemainingBalance = updatedViolationRows.reduce((total, violation) => total + violation.remainingBalance, 0);

                        // Update the balance state with the total remaining balance
                        setBalance(totalRemainingBalance);
                    }
                }
                toast.success(`Payment Voided.`, {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                handleClose();
                setUpdatePaymentBatchNumber('0');
                await updateCaseBalance();
            } catch (err) {
                console.log(err);
                toast.error(`Error Voiding Payment. ${err?.response?.data?.message ? (err?.response?.data?.message ?? '') : ''}`, {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }
        } catch (err) {
            console.log('err voiding payment: ', err);
            toast.error(`Error Settling Chargeback: ${err?.response?.data?.message ? (err?.response?.data?.message ?? 'Error Creating ChargeBack') : ''}`, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        } finally {
            setLoading(false);
        }
    };

    const settleChargeBackWithoutPayment = async (skip) => {
        setLoading(true);
        let paymentNotes;
        if (notes === '') {
            paymentNotes = ""
        } else {
            paymentNotes = notes;
        }
        try {
            await axios.post(`${apiRoute}/api/CreditCardChargeBackTbls/settleChargeBack/${caseNumber}`,
                {
                    paymentIds: [selectedPayment.ccPaymentId],
                    notes: paymentNotes,
                    batchNumber: updatePaymentBatchNumber,
                    chargeBack: chargeBack,
                    settleDate: chargeBackSettleDate
                },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );

            const rows = caseHistoryRows;
            const payment = rows.filter(r => r.pkFfPaymentId === selectedPayment.pkFfPaymentId);
            payment[0].chargeBackSettled = true;
            setCaseHistoryRows(rows);
            toast.success(`CHARGE BACK SETTLED SUCCESSFULLY`, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
            if (!skip) {
                handleClose();
            }
            setUpdatePaymentBatchNumber('0');
            await updateCaseBalance();
        } catch (err) {
            console.log(err);
            toast.error(`Error Settling Charge Back. ${err.message}`, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        } finally {
            setLoading(false);
        }
    };

    const handleBatchOpen = async () => {
        let dayjsBatchDate = dayjs(batchDate);
        const { $D } = dayjsBatchDate;
        if (isNaN($D)) {
            toast.error(`Select a date to open a new batch.`, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        } else {

            const batchData = {
                fkUserId: userId,
                entityId: entityId,
                openDatetime: dayjsBatchDate.toISOString().split('T')[0],
                BatchType: batchType,
                batchName: batchName
            }

            try {
                const res = await axios.post(`${apiRoute}/api/batchtbl`, batchData);
                if (openBatches && openBatches.length > 0) { setOpenBatches([...openBatches, res.data]); }
                else { setOpenBatches([res.data]) }
                toast.success(`Batch ${batchName} (${res?.data?.batchNumber}) opened.`, {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                handleClose();
            } catch (err) {
                console.error('error closing batch', err);
                if (err?.response.status === 400) {
                    toast.error(`Batch already exists with selected Payment Date`, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                } else {
                    toast.error(`Error opening batch ${batchName}.`, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                }
            }
        }
    };

    const handleReceipt = () => {
        let errors = receiptError;
        if (!phoneNumber && textCheck) {
            if (!email && emailCheck) {
                errors = { ...errors, email: 'Required' }
            }
            errors = { ...errors, text: 'Required' }
            setReceiptError(errors)
            return;
        }
        if (!email && emailCheck) {
            if (!phoneNumber && textCheck) {
                errors = { ...errors, text: 'Required' }
            }
            errors = { ...errors, email: 'Required' }
            setReceiptError(errors)
            return;
        }
        setLoading(true);
        axios.get(`${apiRoute}/api/PrintReceiptViews/byReceipt/${receiptNumber}?print=${printCheck}&email=${emailCheck}&phoneNumber=${phoneNumber}&emailAddress=${email}&MasterReceipt=${masterReceipt}`, { responseType: 'arraybuffer' })
            .then((response) => {
                if (printCheck) {
                    const arrayBufferView = new Uint8Array(response.data);
                    const blob = new Blob([arrayBufferView], { type: 'application/pdf' });
                    const dataUrl = URL.createObjectURL(blob);
                    window.open(dataUrl, '_blank');
                }
                if (textCheck) {
                    axios.get(`${apiRoute}/api/PrintReceiptViews/byReceipt/text/${receiptNumber}?phoneNumber=${phoneNumber}&MasterReceipt=${masterReceipt}&caseNumber=${caseNumber}`)
                }
            })
            .then(() => {
                setReceiptNumber('');
                setMasterReceipt(0);
            })
            .catch(error => {
                console.error('Error fetching receipt from front end:', error);
                toast.error('Error handling receipt.', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            })
            .finally(() => {
                handleClose();
                setLoading(false)
            })
    };

    const reprintReceiptWithTextAndEmail = () => {
        let errors = receiptError;
        if (!phoneNumber && textCheck) {
            if (!email && emailCheck) {
                errors = { ...errors, email: 'Required' }
            }
            errors = { ...errors, text: 'Required' }
            setReceiptError(errors)
            return;
        }
        if (!email && emailCheck) {
            if (!phoneNumber && textCheck) {
                errors = { ...errors, text: 'Required' }
            }
            errors = { ...errors, email: 'Required' }
            setReceiptError(errors)
            return;
        }

        const number = phoneNumber === '' ? 0 : phoneNumber;


        if (printCheck && !textCheck && !emailCheck) {
            if (retrieveReceiptPayment[0].receiptImage != null) {
                window.open(retrieveReceiptPayment[0].receiptImage);
                setRetrieveReceiptPayment([]);
                handleClose();
                return;
            } else {
                toast.error('Something Went Wrong ', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                return;
            }
        }

        setLoading(true);
        axios.post(`${apiRoute}/api/PrintReceiptViews/retrieveReceipt?phoneNumber=${number}&email=${email}`, retrieveReceiptPayment[0])
            .then((response) => {
                setLoading(false);
                toast.success('Receipt has been sent successfully!', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            })
            .then((res) => {
                handleClose();
            })
            .then((res) => {
                if (printCheck) {
                    window.open(retrieveReceiptPayment[0]?.receiptImage);
                }
            })
            .catch((err) => {
                console.log('err: ', err.response.data);
                toast.error(err.response.data.message, {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            })
            .finally(() => {
                setLoading(false);
                setRetrieveReceiptPayment([]);
            });
    };

    // CREDIT CARD PAYMENT TYPE DISABLED HERE!!!
    const options = paymentOptions.filter((p) => p.code !== "CREDIT CARD" && p.code !== "TIME SERVED");

    const caseBalanceStyle = {
        "& .MuiInputBase-root": {
            backgroundColor: mode === "dark" ? "#4C4E52" : "white",
            color: mode === "dark" ? "white" : "black",
        },
        "& .MuiInputLabel-root": {
            color: mode === "dark" ? "white" : "black",
            textShadow: mode === "dark" ? "1px 1px 2px black" : "none",
        },
        width: "40%",
    };

    // creditCard modal violation table styles
    const tBackground = mode === 'dark' ? '#313131' : 'white';
    const violationBorder = !!noViolation ? '1px solid #dd4136' : '1px solid transparent'

    useEffect(() => {
        setChargebackFee(violationRows.filter(vr => vr.description === 'CHARGEBACK FEE')[0]?.remainingBalance ?? 0.00);
        setApplyToOverpayment(violationRows.filter(vr => vr.description !== 'CHARGEBACK FEE').every(vr => vr.remainingBalance <= 0));
        setCaseBalance(violationRows.reduce((acc, item) => acc += item.remainingBalance, 0));
        setAmountLeftoverFromSettlement(violationRows.reduce((acc, item) => acc += (item.description !== 'CHARGEBACK FEE' ? item.remainingBalance : 0), 0.00) + selectedPayment.paymentAmount);
    }, [modalType, violationRows, selectedPayment, chargeBackSettlement]);

    useEffect(() => {
        if (applyToViolations) {
            setAmountToApplyToViolations(amountToApplyToOverpayment - chargebackFee + (violationRows.reduce((acc, item) => acc += item.remainingBalance, 0) > selectedPayment.paymentAmount * -1
                ? selectedPayment.paymentAmount
                : (violationRows.reduce((acc, item) => acc += item.remainingBalance, 0) + selectedPayment.paymentAmount) <= 0
                    ? violationRows.reduce((acc, item) => acc += item.remainingBalance, 0)
                    : (violationRows.reduce((acc, item) => acc += item.remainingBalance, 0) + selectedPayment.paymentAmount)))
        }
        if (!applyToViolations) {
            setAmountToApplyToViolations(0.00)
        }
        if (applyToViolations && !applyToOverpayment) {
            if (chargebackFee + amountToApplyToOverpayment + amountToApplyToViolations < selectedPayment.paymentAmount * -1) {
                setAmountToApplyToOverpayment(selectedPayment.paymentAmount * -1 - (chargebackFee + amountToApplyToOverpayment + amountToApplyToViolations))
                setApplyToOverpayment(true);
            }
        }
    }, [applyToViolations]);

    useEffect(() => {
        if (applyToOverpayment && applyToViolations) {
            setAmountToApplyToOverpayment((selectedPayment.paymentAmount * -1) - (chargebackFee + amountToApplyToOverpayment + amountToApplyToViolations));
            return;
        }
        if (applyToOverpayment && !applyToViolations) {
            setAmountToApplyToOverpayment((chargebackFee - selectedPayment.paymentAmount * -1) * -1)
        }
        if (!applyToOverpayment) {
            setAmountToApplyToOverpayment(0.00)
        }
    }, [applyToOverpayment, applyToViolations]);

    async function payViolations() {
        try {
            await settleChargeBackWithoutPayment(true);
            await handleOpen('quickPayment', '75%');
            setLeft([]);
            setRight(applyToOverpayment && chargebackFee === 0 ? violationRows.filter(vr => vr.pkViolationId === selectedPayment.fkViolationId) : applyToOverpayment && !applyToViolations ? violationRows.filter(vr => vr.remainingBalance > 0 && vr.description === 'CHARGEBACK FEE') : violationRows.filter(vr => vr.remainingBalance > 0));
            setPaymentRows([
                {
                    uuid: crypto.randomUUID(),
                    paymentType: 'CHARGEBACK SETTLEMENT',
                    paymentRef: violation.currentStatute,
                    amountRecived: selectedPayment.paymentAmount * -1,
                    displayedAmountRecived: new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(selectedPayment.paymentAmount * -1),
                    paymentAmount: selectedPayment.paymentAmount * -1,
                    displayedPaymentAmount: new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(selectedPayment.paymentAmount * -1),
                    change: 0,
                    displayBalance: formatMoney(balance),
                    balance: balance,
                    checkNumber: '',
                    daysInLieu: violation.daysInLieu,
                    timeServed: violation.timeServed,
                    paymentOptions: paymentOptions.filter(p => p.code === 'CHARGEBACK SETTLEMENT'),
                }
            ]);
        }
        catch (err) {
            console.log('err payViolations(): ', err);
            toast.error('error pay violations: ', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
    };

    const [paymentRows, setPaymentRows] = useState([
        {
            uuid: crypto.randomUUID(),
            paymentType: modalType === 'quickPayment' ? 'MONEY ORDER' : 'TIME SERVED',
            paymentRef: violation.currentStatute,
            amountRecived: 0,
            displayedAmountRecived: '$0.00',
            paymentAmount: modalType === 'quickPayment' ? balance : violationBalance,
            displayedPaymentAmount: modalType === 'quickPayment' ? formatMoney(balance) : formatMoney(violationBalance),
            change: 0,
            displayBalance: modalType === 'quickPayment' ? formatMoney(balance) : formatMoney(violationBalance),
            balance: modalType === 'quickPayment' ? balance : violationBalance,
            checkNumber: '',
            daysInLieu: violation.daysInLieu,
            timeServed: violation.timeServed,
            paymentOptions: modalType === 'quickPayment' ? paymentOptions.filter(p => p.code !== 'TIME SERVED') : paymentOptions.filter(p => p.code === 'TIME SERVED'),
        },
    ]);

    useEffect(() => {
        if (chargeBackSettlement) {
            return;
        }
        setPaymentRows([
            {
                uuid: crypto.randomUUID(),
                paymentType: modalType === 'quickPayment' ? 'MONEY ORDER' : 'TIME SERVED',
                paymentRef: violation.currentStatute,
                amountRecived: 0,
                displayedAmountRecived: '$0.00',
                paymentAmount: modalType === 'quickPayment' ? balance : violationBalance,
                displayedPaymentAmount: modalType === 'quickPayment' ? formatMoney(balance) : formatMoney(violationBalance),
                change: 0,
                displayBalance: modalType === 'quickPayment' ? formatMoney(balance) : formatMoney(violationBalance),
                balance: modalType === 'quickPayment' ? balance : violationBalance,
                checkNumber: '',
                daysInLieu: violation.daysInLieu,
                timeServed: violation.timeServed,
                paymentOptions: modalType === 'quickPayment' ? paymentOptions.filter(p => p.code !== 'TIME SERVED') : paymentOptions.filter(p => p.code === 'TIME SERVED'),
            },
        ])
    }, [modalType, chargeBackSettlement]);

    return (<>
        {
            (modalType === 'newPayment' || modalType === 'quickPayment') && (<Paper elevation={10}>
                <Paper className="border-radius-bottom" sx={{ textAlign: 'center', backgroundColor: 'steelblue', color: 'white', p: '.5vh', display: 'flex', justifyContent: 'center', maxHeight: '3rem' }}>
                    <h3>
                        <strong>
                            {
                                modalType === 'newPayment' ? 'Time Served' : 'Cash & Checks'
                            }
                        </strong>
                    </h3>
                </Paper>
                <Box elevation={10} sx={{ maxHeight: '80vh', minHeight: 'auto', height: 'auto', overflowX: 'hidden', overflowY: 'auto', width: '100%' }}>

                    <Box sx={{ width: '99%', m: 'auto', mt: '.5vh', display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: '.5vh', overflowX: 'auto', }}>
                        {
                            modalType === 'newPayment' && (
                                <Box>
                                    <strong>Violation: {violationView.description}</strong>
                                </Box>
                            )
                        }
                        {
                            modalType === 'quickPayment' && (
                                <>

                                    <Box sx={{ display: 'flex', gap: '0.5rem', alignItems: 'center', justifyContent: 'right', mr: '4vh' }}>
                                        <strong>Current Case Balance: </strong>
                                        <TextField
                                            sx={{ ...caseBalanceStyle, width: '10rem' }}
                                            size="small"
                                            value={commaMoneyFormat(balance)}
                                            id="balance"
                                            inputProps={{ min: 0, style: { textAlign: 'right' }, readOnly: true }}
                                        />
                                    </Box>
                                    <Box sx={{ display: 'flex', gap: '0.5rem', alignItems: 'center', justifyContent: 'right', mr: '4vh' }}>
                                        <strong>Remaining Case Balance After Payment: </strong>
                                        <TextField
                                            sx={{ ...caseBalanceStyle, width: '10rem' }}
                                            size="small"
                                            value={commaMoneyFormat(balance - (totalPayment - change))}
                                            id="balance"
                                            inputProps={{ min: 0, style: { textAlign: 'right' }, readOnly: true }}
                                        />
                                    </Box>
                                </>
                            )
                        }
                        <Box sx={{ display: 'flex', gap: '0.5rem', alignItems: 'center', justifyContent: 'right', mr: '4vh' }}>
                            {modalType === 'quickPayment'
                                ?
                                <strong>Remaining Balance On Selected Violations: </strong>
                                :
                                <strong>Remaining Balance On Selected Violation After Payment: </strong>
                            }
                            <TextField
                                sx={{ ...caseBalanceStyle, width: '10rem' }}
                                size="small"
                                value={commaMoneyFormat(modalType === 'newPayment' && violationBalance > '0.00' ? displayBalance : modalType === 'quickPayment' && newCaseBalance > 0.00 ? newCaseBalance : '0.00')}
                                id="balance"
                                inputProps={{ min: 0, style: { textAlign: 'right' }, readOnly: true }}
                            />
                        </Box>
                    </Box>
                    <Box>
                        <PaymentForm
                            handleClose={handleClose}
                            openBatches={openBatches}
                            violation={violation}
                            updateCaseBalance={updateCaseBalance}
                            modalType={modalType}
                            ts={ts}
                            displayBalance={displayBalance}
                            setDisplayBalance={setDisplayBalance}
                            violationBalance={calculatedViolationBalance}
                            loading={loading}
                            setLoading={setLoading}
                            remitterState={state}
                            remitterDispatch={dispatch}
                            handleOpen={handleOpen}
                            receiptNumber={receiptNumber}
                            setReceiptNumber={setReceiptNumber}
                            setNewCaseBalance={setNewCaseBalance}
                            newCaseBalance={newCaseBalance}
                            citationState={citationState}
                            setMasterReceipt={setMasterReceipt}
                            grand={grand}
                            setGrand={setGrand}
                            change={change}
                            setChange={setChange}
                            totalPayment={totalPayment}
                            setTotalPayment={setTotalPayment}
                            overridedPartialPayment={overridedPartialPayment}
                            violationRows={violationRows}
                            setViolationRows={setViolationRows}
                            checked={checked}
                            setChecked={setChecked}
                            left={left}
                            setLeft={setLeft}
                            right={right}
                            setRight={setRight}
                            paymentRows={paymentRows}
                            setPaymentRows={setPaymentRows}
                            chargeBackSettlement={chargeBackSettlement}
                        />
                    </Box>
                </Box>
                {
                    loading && <LinearProgress />
                }
            </Paper>
            )
        }
        {
            modalType === 'creditCard' && (
                <Paper elevation={10}>
                    <Paper className="border-radius-bottom" sx={{ backgroundColor: 'steelblue', color: 'white', textAlign: 'center', p: '.5vh' }} elevation={10}>
                        <h1>
                            <strong>
                                Credit Card Payment
                            </strong>
                        </h1>
                    </Paper>
                    <Box elevation={10} sx={{ maxHeight: '70vh', minHeight: 'auto', height: 'auto', overflowX: 'hidden', overflowY: 'auto', width: '100%' }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', mt: '2vh', mb: '1vh', width: '100%' }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginRight: '1.5vw', pl: '1vw', width: '45%' }}>
                                <strong>Credit Card Payments Include A Convenience Fee of {convenienceFeeRate}%</strong>
                                <Card sx={{ width: '95%', mt: '1vh', pl: 0 }}>
                                    <CardContent sx={{ p: '2vh' }}>
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <Typography variant="h6" sx={{ flex: 1 }}><strong>Current Case Balance:</strong></Typography>
                                                <Typography variant="h6" sx={{ textAlign: 'right' }}>
                                                    {commaMoneyFormat(currentCaseBalance)}
                                                </Typography>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <Typography variant="h6" sx={{ flex: 1 }}><strong>Remaining Case Balance:</strong></Typography>
                                                <Typography variant="h6" sx={{ textAlign: 'right' }}>
                                                    {commaMoneyFormat(currentCaseBalance - ccPaymentAmount)}
                                                </Typography>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <Typography variant="h6" sx={{ flex: 1 }}><strong>Amount Received:</strong></Typography>
                                                <Typography variant="h6" sx={{ textAlign: 'right' }}>
                                                    {commaMoneyFormat(ccPaymentAmount)}
                                                </Typography>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <Typography variant="h6" sx={{ flex: 1 }}><strong>Convenience Fee:</strong></Typography>
                                                <Typography variant="h6" sx={{ textAlign: 'right' }}>
                                                    {commaMoneyFormat(convenienceFee)}
                                                </Typography>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <Typography variant="h6" sx={{ flex: 1 }}><strong>Grand Total:</strong></Typography>
                                                <Typography variant="h6" sx={{ textAlign: 'right' }}>
                                                    {commaMoneyFormat(grandTotal)}
                                                </Typography>
                                            </div>
                                        </div>
                                    </CardContent>
                                </Card>
                            </Box>
                            <Box sx={{ width: '60%', m: '0 auto' }}>
                                {
                                    quickCheck === false && (
                                        <Box sx={{ m: '0' }}>
                                            <Paper sx={{ ml: '.2vw', mr: '1vw' }} elevation={10}>
                                                <Paper className="border-radius-bottom" sx={{ backgroundColor: 'steelblue', color: 'white', textAlign: 'center', p: '.5vh' }} elevation={10}>
                                                    <h4>
                                                        <strong>
                                                            Select a violation for this payment
                                                        </strong>
                                                    </h4>
                                                </Paper>
                                                <div style={{ maxHeight: '33vh', minHeight: 'auto', height: 'auto', overflow: 'auto', pl: '1vh', pr: '1vh', pt: '0', pb: '1vh', display: 'flex', justifyContent: 'center' }}>
                                                    <table style={{ borderCollapse: 'separate', textAlign: 'center', width: '100%', tableLayout: 'fixed' }}>

                                                        <thead>
                                                            <tr style={{ position: 'sticky', top: 0, backgroundColor: tBackground, zIndex: 1, width: '100%' }}>
                                                                <th style={{ width: '12%', wordWrap: 'break-word' }}></th>
                                                                <th style={{ width: '25%', wordWrap: 'break-word' }}>Charge Type</th>
                                                                <th style={{ width: '20%', wordWrap: 'break-word' }}>Statute</th>
                                                                <th style={{ width: '25%', wordWrap: 'break-word' }}>Description</th>
                                                                <th style={{ width: '20%', wordWrap: 'break-word' }}>Balance</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {chargesRows?.filter(cr => cr?.amendedDate == null).map((v, index) => {
                                                                const { pkViolationId, chargeType, currentStatute, description, remainingBalance } = v;
                                                                return (
                                                                    <tr key={pkViolationId}>
                                                                        <td>
                                                                            <FormControlLabel key={index}
                                                                                value={state?.violationIdFk}
                                                                                control={<Checkbox />}
                                                                                checked={checkedItems?.findIndex(c => c?.pkViolationId === pkViolationId) !== -1}
                                                                                onChange={() => {
                                                                                    const checkedItemIndex = checkedItems?.findIndex((item) => item?.pkViolationId === pkViolationId);
                                                                                    if (checkedItemIndex === -1) {
                                                                                        setCheckedItems([...checkedItems, v]);
                                                                                        setPkViolations([...pkViolations, v]);
                                                                                    } else if (checkedItemIndex > -1) {
                                                                                        const updatedCheckedItems = checkedItems.filter((item) => item.pkViolationId !== pkViolationId);
                                                                                        setCheckedItems(updatedCheckedItems);
                                                                                        setPkViolations(updatedCheckedItems);
                                                                                    }
                                                                                }}
                                                                            />
                                                                        </td>
                                                                        <td>{chargeType}</td>
                                                                        <td style={{ paddingLeft: '' }}>{currentStatute}</td>
                                                                        <td style={{ paddingLeft: '' }}>{description}</td>
                                                                        <td style={{ paddingLeft: '' }}>{commaMoneyFormat(remainingBalance)}</td>
                                                                    </tr>
                                                                );
                                                            })}
                                                            <hr fullWidth width="1000%" />
                                                        </tbody>
                                                        <tfoot>
                                                            <tr key={"grand total"}><td>
                                                                <div key={"violation total"}
                                                                    value={checkedItems.reduce((acc, output) => {
                                                                        acc += output.totalCosts;
                                                                        acc += output.totalFees;
                                                                        acc += output.totalFines;
                                                                        return acc;
                                                                    }, 0.00)}
                                                                />
                                                            </td>
                                                                <td
                                                                    style={{
                                                                        paddingLeft: ''
                                                                    }}
                                                                >
                                                                    <strong>
                                                                        VIOLATIONS SELECTED
                                                                    </strong>
                                                                </td>
                                                                <td
                                                                    style={{
                                                                        paddingLeft: '',
                                                                        color: checkedItems.length > 0 ? 'lime' : 'indianred'
                                                                    }}
                                                                >
                                                                    {checkedItems?.length ? checkedItems.length : <strong>0</strong>}
                                                                </td>
                                                                <td>
                                                                    <strong>
                                                                        VIOLATION(s) PAYMENT TOTAL
                                                                    </strong>
                                                                </td>
                                                                <td
                                                                    style={{
                                                                        paddingLeft: '',
                                                                        color: checkedItems.length > 0 ? 'lime' : 'indianred'
                                                                    }}
                                                                >
                                                                    <strong>
                                                                        {
                                                                            commaMoneyFormat(checkedItems.reduce((acc, output) => {
                                                                                acc += output.totalCosts;
                                                                                acc += output.totalFees;
                                                                                acc += output.totalFines;
                                                                                return acc;
                                                                            }, 0.00))
                                                                        }
                                                                    </strong>
                                                                </td>
                                                            </tr>
                                                        </tfoot>
                                                    </table>
                                                </div>
                                            </Paper>
                                            {pkViolations.length === 0 && <Box sx={{ textAlign: 'center', mt: '1vh' }}>
                                                {
                                                    pkViolations.length === 0 && <span style={{ color: '#dd4136' }}>PLEASE SELECT A VIOLATION</span>
                                                }
                                            </Box>}
                                        </Box>
                                    )
                                }
                            </Box>
                        </Box>

                        <Box sx={{ width: '99%', m: '1vh auto' }} pb={'1vh'}>
                            <CreditCardModal
                                ts={ts}
                                violation={violation}
                                setViolation={setViolation}
                                setLoading={setLoading}
                                loading={loading}
                                quickCheck={quickCheck}
                                updateCaseBalance={updateCaseBalance}
                                handleClose={handleClose}
                                setNoViolation={setNoViolation}
                                violationBalance={violationBalance}
                                convenienceFee={convenienceFee}
                                setConvenienceFee={setConvenienceFee}
                                convenienceRate={convenienceRate}
                                grandTotal={grandTotal}
                                setGrandTotal={setGrandTotal}
                                setCcPaymentAmount={setCcPaymentAmount}
                                ccPaymentAmount={ccPaymentAmount}
                                setReceiptNumber={setReceiptNumber}
                                handleOpen={handleOpen}
                                setMasterReceipt={setMasterReceipt}
                                isCCPayment={true}
                                statuteDesc={selectedStatuteDesc}
                                selectedViolations={pkViolations}
                                checkedItems={checkedItems}
                            />
                        </Box>
                    </Box>
                    {
                        loading && <LinearProgress />
                    }
                </Paper>
            )
        }
        {
            modalType === 'editType' && (
                <Paper elevation={10}>
                    <Paper sx={{ backgroundColor: 'steelblue', color: 'white', p: '.5vh', textAlign: 'center' }} elevation={10}>
                        <h1>
                            <strong>Edit Payment Type</strong>
                        </h1>
                    </Paper>
                    <Box sx={{ p: '1rem', display: 'flex' }}>
                        <Box p={'1rem'}>
                            <TextField
                                select
                                id="paymentType"
                                label="Type"
                                variant="outlined"
                                defaultValue={options[0].description}
                                InputLabelProps={{ shrink: true }}
                                value={paymentType}
                                onChange={(e) => { setPaymentType(e.target.value) }}
                            >
                                {
                                    options?.map(({ code, description }) => {
                                        return <MenuItem key={code} value={code}>{description}</MenuItem>
                                    })
                                }
                            </TextField>
                        </Box>
                        {
                            (paymentType === "MONEY ORDER" || paymentType === "CCHECK") &&
                            <Box sx={{ p: '1rem', maxWidth: '12rem' }}>
                                <TextField
                                    id="checkNumber"
                                    label="Check Number"
                                    variant="outlined"
                                    width="auto"
                                    InputLabelProps={{ shrink: true }}
                                    value={selectedPayment.checkNumber}
                                    onChange={(e) => { setCheckNumber(e.target.value.replace(/[^0-9.]/g, '')) }}
                                />
                            </Box>
                        }
                        <Box sx={{ display: 'flex', p: '1rem' }}>
                            <Button variant="contained" onClick={editPaymentType} sx={{ float: 'right', mr: '2rem', py: '1rem', backgroundColor: 'steelblue', color: 'white' }}>
                                Save Changes
                            </Button>
                            <Button variant="contained" onClick={handleClose} sx={{ float: 'right', backgroundColor: 'steelblue', color: 'white' }}>
                                Cancel
                            </Button>
                        </Box>
                    </Box>
                    {
                        loading && <LinearProgress />
                    }
                </Paper>
            )
        }
        {
            (modalType === 'refundPayment' || modalType === 'reversePayment' || modalType === 'voidPayment') && (
                <>
                    <Paper elevation={10}>
                        <Paper sx={{ backgroundColor: 'steelblue', color: 'white', p: '.5vh', textAlign: 'center' }} elevation={10}>
                            <h1>
                                <strong>
                                    {modalType === 'refundPayment' ? 'Refund Payment' : modalType === 'voidPayment' ? 'Void Payment' : 'Reverse Payment'}
                                </strong>
                            </h1>
                        </Paper>
                        <Box sx={{ p: '1rem', pb: '.5rem' }}>
                            <h5>Do you want to {modalType === 'refundPayment' ? 'REFUND' : modalType === 'voidPayment' ? 'VOID' : 'REVERSE'} the {selectedPayment.paymentType} payment made on {selectedPayment.dateEnter} of {commaMoneyFormat(selectedPayment.paymentAmount)} for violation {selectedPayment.paymentRef}?</h5>
                        </Box>
                        {selectedPayment.paymentType === 'CREDIT CARD'
                            ? <Box sx={{ display: 'flex', alignItems: 'center', p: '1rem', pt: '0rem', pb: '.3rem', gap: '.5rem', flexDirection: 'row', justifyContent: 'flex-start' }}>
                                <Box sx={{ m: '.75rem 1rem 0 0' }}><h6>Are you issuing a Credit Card Chargeback?</h6></Box>
                                <FormControlLabel
                                    sx={{}}
                                    value={state?.violationIdFk}
                                    control={<Checkbox />}
                                    checked={chargeBack}
                                    onChange={() => setChargeBack(!chargeBack)}
                                />
                            </Box>
                            : <></>}
                        {
                            (modalType === 'refundPayment' || modalType === 'reversePayment') && (
                                <Box sx={{ p: '1vh' }}>
                                    <RemitterForm
                                        ts={ts}
                                        dispatch={dispatch}
                                        state={state}
                                        selectedPayment={selectedPayment}
                                        calledFrom="Case History"
                                        modalType={modalType}
                                    />
                                </Box>
                            )
                        }
                        <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: 'center', overflow: 'hidden' }}>
                            <h6 style={{ marginTop: '1vh', marginLeft: '1rem' }}>Batches: </h6>&nbsp;&nbsp;
                            <Box sx={{ width: '100%' }}>
                                <RadioGroup
                                    row
                                    name='voidBatchNumber'
                                    value={updatePaymentBatchNumber}
                                    onChange={(e) => setUpdatePaymentBatchNumber(e.target.value)}
                                >
                                    {
                                        // destructured batchNumber out of batch object to make this easier to read
                                        openBatches.sort((a, b) => a.batchNumber < b.batchNumber ? -1 : 1).map(({ batchName, batchNumber }) => (
                                            <FormControlLabel
                                                key={batchNumber}
                                                value={batchNumber}
                                                control={<Radio />}
                                                label={batchName ? `${batchName}(${batchNumber})` : batchNumber}
                                            />
                                        ))
                                    }
                                </RadioGroup>
                            </Box>
                        </Box>
                        <Box sx={{ p: '1vh' }}>
                            <TextField
                                sx={ts}
                                multiline
                                rows={6}
                                value={notes}
                                onChange={(e) => setNotes(e.target.value)}
                                fullWidth
                                label="Comments"
                                variant="outlined"
                                inputProps={{ maxLength: 100 }}
                            />
                        </Box>
                        <Box sx={{ display: 'flex', gap: '1rem', justifyContent: 'right', p: '1vh' }}>
                            <Button
                                onClick={
                                    modalType === 'refundPayment' ? refundPayment
                                        : modalType === 'voidPayment' ? voidPayment
                                            : reversePayment
                                }
                                variant="contained"
                                sx={{ backgroundColor: 'steelblue', color: 'white' }}
                                disabled={notes.length < 1}
                            >
                                {modalType === 'refundPayment' ? 'Refund'
                                    : modalType === 'voidPayment' ? 'Void'
                                        : 'Reverse'} Payment
                            </Button>
                            <Button
                                onClick={() => handleClose() && setUpdatePaymentBatchNumber('0')}
                                variant="contained"
                                sx={{ backgroundColor: 'steelblue', color: 'white' }}
                            >
                                Cancel
                            </Button>
                        </Box>
                    </Paper>
                    {
                        loading && <LinearProgress />
                    }
                </>
            )
        }
        {
            (modalType === 'settleChargeback') ? (
                <>
                    <Paper elevation={10}>
                        <Paper sx={{ backgroundColor: 'steelblue', color: 'white', p: '.5vh', textAlign: 'center' }} elevation={10}>
                            <h1>
                                <strong>
                                    Settle Chargeback
                                </strong>
                            </h1>
                        </Paper>
                        <Box sx={{ p: '1.5rem', pb: '.5rem' }}>
                            <h5>Do you wish to Settle the {selectedPayment.paymentType} made on {selectedPayment.dateEnter} of {commaMoneyFormat(selectedPayment.paymentAmount)}, for violation {`${selectedPayment?.paymentRef}` ?? ''} {violationRows.filter(vr => vr.pkViolationId === selectedPayment.fkViolationId)[0]?.description ?? ''}?</h5>
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'row', gap: '1rem', width: '100%' }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', p: '2rem', pt: '.5rem', justifyContent: 'center', alignItems: 'center' }}>
                                <Typography variant='subtitle1'>
                                    Settle Date
                                </Typography>
                                <TextField
                                    type="date"
                                    sx={{ width: '100%' }}
                                    onChange={(e) => setChargeBackSettleDate(e.target.value)}
                                />
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', p: '1rem', pt: '0rem', pb: '.3rem', gap: '.5rem', flexDirection: 'row', justifyContent: 'flex-start' }}>
                                <Box sx={{ m: '.75rem 1rem 0 0' }}><h6>Are You Issuing A Charge Back Settlement Payment?</h6></Box>
                                <FormControlLabel
                                    sx={{}}
                                    control={<Checkbox />}
                                    checked={chargeBackSettlement}
                                    onChange={() => setChargeBackSettlement(!chargeBackSettlement)}
                                />
                            </Box>
                        </Box>
                        {
                            chargeBackSettlement
                                ? violationRows.filter(vr => vr.pkViolationId === selectedPayment.fkViolationId)[0]?.remainingBalance > 0
                                    ? <Box sx={{ display: "flex", justifyContent: 'flex-start', alignItems: 'center', width: '100%', p: '2rem', pt: '0rem', gap: '1rem' }}>
                                        <Typography variant='subtitle1' sx={{ marginTop: '.5vh', width: 'auto' }}>Batch To Be Collected In: </Typography>
                                        <Box sx={{ display: 'flex', width: 'auto' }}>
                                            <RadioGroup
                                                row
                                                name='voidBatchNumber'
                                                value={updatePaymentBatchNumber}
                                                onChange={(e) => setUpdatePaymentBatchNumber(e.target.value)}
                                            >
                                                {
                                                    // destructured batchNumber out of batch object to make this easier to read
                                                    openBatches.sort((a, b) => a.batchNumber < b.batchNumber ? -1 : 1).map(({ batchName, batchNumber }) => (
                                                        <FormControlLabel
                                                            key={batchNumber}
                                                            value={batchNumber}
                                                            control={<Radio />}
                                                            label={batchName ? `${batchName}(${batchNumber})` : batchNumber}
                                                        />
                                                    ))
                                                }
                                            </RadioGroup>
                                        </Box>
                                    </Box>
                                    : <Box sx={{ p: '2rem', pt: 0 }}>
                                        <strong>VIOLATION {selectedPayment?.paymentRef ?? ''} {violationRows.filter(vr => vr.pkViolationId === selectedPayment.fkViolationId)[0]?.description ?? ''}, IS ALREADY PAID IN FULL!</strong><br /> CHARGEBACK SETTLEMENT CANNOT BE APPLIED TO THIS VIOLATION DIRECTLY WITHOUT CREATING OVERPAYMENT. HOW WOULD YOU LIKE TO PROCEED?
                                        <Box sx={{ display: 'flex', flexDirection: 'column', pt: '.25rem', justifyContent: 'center', alignItems: 'center' }}>
                                            <Box sx={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', width: '60%' }}>
                                                    <Typography variant='body1' sx={{ mt: '.5rem' }}>SELECT OPTIONS TO APPLY:</Typography>
                                                    <FormControlLabel
                                                        key={'CHARGEBACKFEE'}
                                                        control={<Tooltip title='THIS WILL DEFAULT TO BEING CHECKED IF THE AMOUNT DUE ON THE VIOLATION IS GREATER THAN $0.00, OTHERWISE OPTION IS DISABLED'>
                                                            <span>
                                                                <Checkbox
                                                                    checked={violationRows.filter(vr => vr.description === 'CHARGEBACK FEE')[0]?.remainingBalance > 0}
                                                                    disabled={violationRows.filter(vr => vr.description === 'CHARGEBACK FEE')[0]?.remainingBalance <= 0}
                                                                />
                                                            </span>
                                                        </Tooltip>}
                                                        label='PAY CHARGEBACK FEE'
                                                        disabled={violationRows.filter(vr => vr.description === 'CHARGEBACK FEE')[0]?.remainingBalance <= 0}
                                                    />

                                                    <FormControlLabel
                                                        key={'VIOLATIONS'}
                                                        checked={applyToViolations}
                                                        onChange={() => setApplyToViolations(!applyToViolations)}
                                                        control={<Checkbox />}
                                                        label='PAY OUTSTANDING VIOLATIONS'
                                                        disabled={(applyToOverpayment && !applyToViolations && (selectedPayment.paymentAmount * -1) - (chargebackFee + amountToApplyToOverpayment + amountToApplyToViolations) === 0.00) ? true : violationRows.filter(vr => vr.description !== 'CHARGEBACK FEE').every(vr => vr.remainingBalance <= 0.00) ? true : applyToOverpayment && amountLeftoverFromSettlement > 0}
                                                    />
                                                    <FormControlLabel
                                                        key={'OVERPAYMENT'}
                                                        checked={applyToOverpayment}
                                                        onChange={() => setApplyToOverpayment(!applyToOverpayment)}
                                                        control={<Checkbox />}
                                                        label='APPLY OVERPAYMENT'
                                                        disabled={applyToViolations && amountLeftoverFromSettlement > 0}
                                                    />
                                                </Box>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', width: '70%', border: mode === 'dark' ? 'solid 1px white' : 'solid 1px black', borderRadius: '6px', p: '1rem', pt: '.5rem' }}>
                                                    <Box sx={{ display: 'flex', flexDirection: 'column', mb: '.15rem' }}>
                                                        <Box sx={{ display: 'flex' }}><Typography><strong>Settlement Amount:</strong></Typography><Typography sx={{ ml: 'auto' }}><strong>{commaMoneyFormat(selectedPayment.paymentAmount * -1)}</strong></Typography></Box>
                                                        <Box sx={{ display: 'flex' }}><Typography>Amount Allocated:</Typography><Typography sx={{ ml: 'auto', color: chargebackFee + amountToApplyToOverpayment + amountToApplyToViolations < selectedPayment.paymentAmount * -1 ? 'indianred' : 'limegreen' }}>{commaMoneyFormat(chargebackFee + amountToApplyToOverpayment + amountToApplyToViolations)}</Typography></Box>
                                                        <Typography variant='body1' sx={{ mt: '.5rem', textDecoration: 'underline' }}>Worksheet</Typography>
                                                    </Box>
                                                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                                        <Box sx={{ display: 'flex' }}><Typography sx={{ width: '100%' }}><strong>Current Case Balance:</strong></Typography><Typography sx={{ ml: 'auto' }}><strong>{commaMoneyFormat(caseBalance)}</strong></Typography></Box>
                                                        <em><Box sx={{ display: 'flex' }}><Typography> ChargeBack Fee:</Typography><Typography sx={{ ml: 'auto', color: 'limegreen' }}>-{commaMoneyFormat(chargebackFee)}</Typography></Box></em>
                                                        {applyToViolations ? <em><Box sx={{ display: 'flex' }}><Typography> Apply Remaining:</Typography><Typography sx={{ ml: 'auto', color: 'limegreen' }}>-{commaMoneyFormat(amountToApplyToViolations)}</Typography></Box></em> : <></>}
                                                        {applyToOverpayment ? <em><Box sx={{ display: 'flex' }}><Typography> Overpayment Amount:</Typography><Typography sx={{ ml: 'auto', color: 'indianred' }}>{commaMoneyFormat(amountToApplyToOverpayment)}</Typography></Box></em> : <></>}
                                                        <Box sx={{ display: 'flex', borderTop: mode === 'dark' ? 'solid 1px white' : 'solid 1px black' }}>
                                                            <Typography><strong>End Case Balance:</strong></Typography><Typography sx={{ ml: 'auto' }}>
                                                                <strong>
                                                                    {
                                                                        commaMoneyFormat(
                                                                            applyToOverpayment && !applyToViolations
                                                                                ? caseBalance - (chargebackFee + amountToApplyToViolations)
                                                                                : caseBalance - (chargebackFee + amountToApplyToViolations) - amountToApplyToOverpayment
                                                                        )
                                                                    }
                                                                </strong>
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                : <></>
                        }
                        <Box sx={{ display: 'flex', gap: '1rem', justifyContent: 'right', p: '1vh' }}>
                            <Button
                                onClick={async (e) => chargeBackSettlement ? violationRows.filter(vr => vr.pkViolationId === selectedPayment.fkViolationId)[0]?.remainingBalance <= 0 ? await payViolations() : await createChargeBackSettlementPayment() : await settleChargeBackWithoutPayment(false)}
                                variant="contained"
                                sx={{ backgroundColor: 'steelblue', color: 'white' }}
                                disabled={violationRows.filter(vr => vr.pkViolationId === selectedPayment.fkViolationId)[0]?.remainingBalance <= 0 ? ((caseBalance - (chargebackFee + amountToApplyToOverpayment + amountToApplyToViolations)) !== (caseBalance + selectedPayment.paymentAmount)) : chargeBackSettlement ? updatePaymentBatchNumber === '0' : !chargeBackSettleDate}
                            >
                                Settle Chargeback
                            </Button>
                            <Button
                                onClick={() => handleClose() && setUpdatePaymentBatchNumber('0')}
                                variant="contained"
                                sx={{ backgroundColor: 'steelblue', color: 'white' }}
                            >
                                Cancel
                            </Button>
                        </Box>
                    </Paper>
                    {
                        loading && <LinearProgress />
                    }
                </>
            )
                : <></>
        }
        {
            modalType === 'openBatch' && (
                <OpenBatchModal
                    ts={ts}
                    batchDate={batchDate}
                    setBatchDate={setBatchDate}
                    handleBatchOpen={handleBatchOpen}
                    batchType={batchType}
                    setBatchType={setBatchType}
                    handleClose={handleClose}
                    modalType={modalType}
                    selectedRow={selectedRow}
                    batchName={batchName}
                    setBatchName={setBatchName}
                />
            )
        }
        {
            modalType === 'printReceipt' && (
                <Paper elevation={10}>
                    <Paper sx={{ backgroundColor: 'steelblue', color: 'white', p: '.5vh', textAlign: 'center' }} elevation={10}>
                        <h1>
                            <strong>Print/Email Receipt</strong>
                        </h1>
                    </Paper>
                    <Box sx={{ p: '1rem' }}>
                        <h5 style={{ textAlign: 'center' }}>
                            Do you want to print or email or text a receipt for this payment?
                        </h5>
                        <hr />
                        <Box sx={{ display: 'flex', gap: '2rem', justifyContent: 'center' }}>
                            <FormControlLabel
                                control={<Checkbox checked={printCheck} onChange={(e) => setPrintCheck(e.target.checked)} />}
                                label="Print"
                            />
                            <FormControlLabel
                                control={<Checkbox checked={emailCheck} onChange={(e) => setEmailCheck(e.target.checked)} />}
                                label="Email"
                            />
                            <FormControlLabel
                                control={<Checkbox checked={textCheck} onChange={(e) => setTextCheck(e.target.checked)} />}
                                label="Text"
                            />
                        </Box>
                        {
                            emailCheck &&
                            <Box sx={{ mt: '1vh', mb: '1vh' }}>
                                <h5 style={{ textAlign: 'center' }}>
                                    Enter the email to send the receipt to below.
                                </h5>
                                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                    <TextField
                                        sx={{ width: '75%' }}
                                        id="email"
                                        variant="outlined"
                                        value={email}
                                        onChange={(e) => { setEmail(e.target.value) }}
                                        onBlur={(e) => {
                                            !e.target.value
                                                ? setReceiptError({ ...receiptError, email: 'Required' })
                                                : setReceiptError({ ...receiptError, email: null })
                                        }}
                                        helperText={receiptError?.email}
                                        error={!!receiptError?.email}
                                    />
                                </Box>
                            </Box>
                        }
                        {textCheck &&
                            <Box sx={{ mt: '1vh', mb: '1vh' }}>
                                <h5 style={{ textAlign: 'center' }}>
                                    Enter the phone number to send the receipt to below.
                                </h5>
                                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                    <TextField
                                        sx={{ width: '75%' }}
                                        id="phoneNumber"
                                        variant="outlined"
                                        value={phoneNumber}
                                        onChange={(e) => { setPhoneNumber(e.target.value) }}
                                        onBlur={(e) => {
                                            !e.target.value
                                                ? setReceiptError({ ...receiptError, text: 'Required' })
                                                : setReceiptError({ ...receiptError, text: null })
                                        }}
                                        helperText={receiptError?.text}
                                        error={!!receiptError?.text}
                                    />
                                </Box>
                            </Box>
                        }
                        <hr />
                        <Box sx={{ display: 'flex', gap: '1rem', justifyContent: 'right', }}>
                            <Button variant="contained" onClick={handleReceipt} sx={{ backgroundColor: 'steelblue', color: 'white' }}>Print/Send Receipt</Button>
                            <Button variant="contained" onClick={() => { handleReceipt(); setReceiptNumber(''); setMasterReceipt(0) }} sx={{ backgroundColor: 'steelblue', color: 'white' }}>Skip</Button>
                        </Box>
                    </Box>
                    {
                        loading && <LinearProgress />
                    }
                </Paper>
            )
        }
        {
            modalType === 'retrieveReceipt' && (
                <Paper elevation={10}>
                    <Paper sx={{ backgroundColor: 'steelblue', color: 'white', p: '.5vh', textAlign: 'center' }} elevation={10}>
                        <h1>
                            <strong>Print/Email Receipt</strong>
                        </h1>
                    </Paper>
                    <Box sx={{ p: '1rem' }}>
                        <h5 style={{ textAlign: 'center' }}>
                            Would you like to reprint, email or text the original receipt for this payment?
                        </h5>
                        <hr />
                        <Box sx={{ display: 'flex', gap: '2rem', justifyContent: 'center' }}>
                            {
                                !!retrieveReceiptPayment[0]?.receiptImage && (
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={printCheck}
                                                onChange={(e) => setPrintCheck(e.target.checked)}
                                            />
                                        }
                                        label="Print"
                                    />
                                )
                            }
                            <FormControlLabel
                                control={<Checkbox checked={emailCheck} onChange={(e) => setEmailCheck(e.target.checked)} />}
                                label="Email"
                            />
                            <FormControlLabel
                                control={<Checkbox checked={textCheck} onChange={(e) => setTextCheck(e.target.checked)} />}
                                label="Text"
                            />
                        </Box>
                        {
                            emailCheck &&
                            <Box sx={{ mt: '1vh', mb: '1vh' }}>
                                <h5 style={{ textAlign: 'center' }}>
                                    Enter the email to send the receipt to below.
                                </h5>
                                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                    <TextField
                                        sx={{ width: '75%' }}
                                        id="email"
                                        variant="outlined"
                                        value={email}
                                        onChange={(e) => { setEmail(e.target.value) }}
                                        onBlur={(e) => {
                                            !e.target.value
                                                ? setReceiptError({ ...receiptError, email: 'Required' })
                                                : setReceiptError({ ...receiptError, email: null })
                                        }}
                                        helperText={receiptError?.email}
                                        error={!!receiptError?.email}
                                    />
                                </Box>
                            </Box>
                        }
                        {textCheck &&
                            <Box sx={{ mt: '1vh', mb: '1vh' }}>
                                <h5 style={{ textAlign: 'center' }}>
                                    Enter the phone number to send the receipt to below.
                                </h5>
                                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                    <TextField
                                        sx={{ width: '75%' }}
                                        id="phoneNumber"
                                        variant="outlined"
                                        value={phoneNumber}
                                        onChange={(e) => { setPhoneNumber(e.target.value) }}
                                        onBlur={(e) => {
                                            !e.target.value
                                                ? setReceiptError({ ...receiptError, text: 'Required' })
                                                : setReceiptError({ ...receiptError, text: null })
                                        }}
                                        helperText={receiptError?.text}
                                        error={!!receiptError?.text}
                                    />
                                </Box>
                            </Box>
                        }
                        <hr />
                        <Box sx={{ display: 'flex', gap: '1rem', justifyContent: 'right', }}>
                            <Button variant="contained" onClick={reprintReceiptWithTextAndEmail} sx={{ backgroundColor: 'steelblue', color: 'white' }}>Print/Send Receipt</Button>
                            <Button variant="contained" onClick={() => { handleClose(); setReceiptNumber(''); setMasterReceipt(0); setRetrieveReceiptPayment([]) }} sx={{ backgroundColor: 'steelblue', color: 'white' }}>Cancel</Button>
                        </Box>
                    </Box>
                    {
                        loading && <LinearProgress />
                    }
                </Paper>
            )
        }
    </>);
}

export default PaymentModals;